import { Card, Header } from '@breward/ui';
import { useTranslation } from 'react-i18next';

import { hasProfile, PROFILE_AXES, ProfileAxis, readProfile } from '../profile';
import { BeerGuidelines } from '../types';
import { ProfileRangeBar } from './ProfileRangeBar';

interface ProfileCardProps {
  gl?: BeerGuidelines;
}

export const ProfileCard = ({ gl }: ProfileCardProps) => {
  const [t] = useTranslation();

  const profile = readProfile(gl);

  if (!hasProfile(profile)) return null;

  const labels: Record<ProfileAxis, string> = {
    bitterness: t('Pages:ParticipantWeb.ShowStylePage.Profile.bitterness', 'Goryczka'),
    hoppiness: t('Pages:ParticipantWeb.ShowStylePage.Profile.hoppiness', 'Chmielowość'),
    maltiness: t('Pages:ParticipantWeb.ShowStylePage.Profile.maltiness', 'Słodowość'),
    body: t('Pages:ParticipantWeb.ShowStylePage.Profile.body', 'Pełnia'),
    esters: t('Pages:ParticipantWeb.ShowStylePage.Profile.esters', 'Estry'),
    sourness: t('Pages:ParticipantWeb.ShowStylePage.Profile.sourness', 'Kwaśność'),
    smokiness: t('Pages:ParticipantWeb.ShowStylePage.Profile.smokiness', 'Wędzoność'),
  };

  return (
    <Card className="p-5">
      <div className="col-span-12 flex flex-col gap-4">
        <Header
          variant="card"
          title={t('Pages:ParticipantWeb.ShowStylePage.Profile.title', 'Profil stylu')}
        />
        <div className="space-y-4">
          {PROFILE_AXES.map((axis) => {
            const range = profile[axis];
            return range ? (
              <ProfileRangeBar key={axis} label={labels[axis]} range={range} />
            ) : null;
          })}
        </div>
        <p className="font-sans text-[11px] leading-snug text-primary-500">
          {t(
            'Pages:ParticipantWeb.ShowStylePage.Profile.disclaimer',
            'Orientacyjny zakres cech. Obowiązujący jest opis tekstowy stylu.',
          )}
        </p>
      </div>
    </Card>
  );
};
